import { useLocation } from 'react-router-dom'

import { useAuth } from 'pkg/authentication'

import useWhitelist from 'hooks/useWhitelist'


export default function useCanViewPage() {
  const { isExcludedPathname } = useAuth()
  const { pathname } = useLocation()

  const {
    isLoading,
    isPageWhitelisted,
    isPlanWhitelisted,
  } = useWhitelist()

  const isExcluded = isExcludedPathname(pathname)
  const isWhitelisted = ( isPageWhitelisted && isPlanWhitelisted )

  return {
    isLoading,
    canViewPage: ( isWhitelisted || !isExcluded ),
  }
}
